import React from "react";
import "./DeceasedPill.scss";

/** True however the flag arrives: a boolean from the API, 1 from a raw query, "1" from the Arc gateway. */
export const isDeceased = (investor) => Boolean(investor) && [true, 1, "1"].includes(investor.DECEASED);

const DeceasedPill = ({investor}) => (isDeceased(investor) ? <span className="DeceasedPill">Deceased</span> : null);

export default DeceasedPill;
